import {differenceInYears, format} from 'date-fns';
import pluralize from 'pluralize';

const fmt = (value, dateFormat) => {
  if (!value) {
    return '';
  }

  return format(new Date(value), dateFormat);
};

export const formatAge = (dob) => {
  const yrs = dob ? differenceInYears(new Date(), new Date(dob)) : '';
  return yrs || yrs === 0 ? `${yrs}${pluralize('yr', yrs, false)}` : '';
};

export const formatDate = (date) => fmt(date, 'MM/dd/yy');
export const formatDateTime = (dateTime) => fmt(dateTime, `MM/dd/yy h:mm a`);
